import React, { useEffect, useState } from "react";
import "./ManageAds.css";
import { API } from "../../constants/Api";
import { toast } from "react-toastify";
import { Modal } from "antd";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import { format, addDays } from "date-fns";
import DataTable from "react-data-table-component";
function ManageAds() {
  const token = localStorage.getItem("token");
  const advId = localStorage.getItem("advertiserId");

  const [data, setData] = useState([]);
  const [options, setOptions] = useState([]);
  const [selectedZipCodes, setSelectedZipCodes] = useState([]);
  const [selected, setSelected] = useState([]);
  const [modalType, setModalType] = useState(null);
  const [featured, setFeatured] = useState([]); // Changed from string to array
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(false);
  const [loading, setLoading] = useState(false);
  const [normal, setNoraml] = useState([]);
  const [featured2, setFeatured2] = useState([]);
  const area_of_operation = localStorage.getItem("area_of_operation")
    ? JSON.parse(localStorage.getItem("area_of_operation"))
    : [];
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const openModal = (type) => setModalType(type);
  const closeModal = () => setModalType(null);

  // const handleZipChange = (selectedOption) => {
  //   setSelectedZipCodes(
  //     selectedOption ? selectedOption.map((opt) => opt.value) : []
  //   );
  // };
  const handleZipChange = (selectedOption) => {
    setSelectedZipCodes(selectedOption || []);
  };
  // useEffect(() => {
  //   const storedZipCodes = localStorage.getItem("area_of_operation");
  //   if (storedZipCodes) {
  //     try {
  //       const parsedZipCodes = JSON.parse(storedZipCodes);
  //       const zipOptions = parsedZipCodes.map((data) => ({
  //         label: data,
  //         value: data,
  //       }));
  //       setSelectedZipCodes(zipOptions);
  //     } catch (error) {
  //       console.error("Error parsing zip codes from localStorage:", error);
  //       setSelectedZipCodes([]);
  //     }
  //   }
  // }, []);
  useEffect(() => {
    const getOptions = async (data1) => {
      try {
        const response = await fetch(
          `${API}/advertiser/get-Advertiser/${advId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const json = await response.json();

        if (response.ok) {
          const zipOptions =
            json.data.advertiserBussninesinfo.areaof_Operation.map((data) => ({
              label: data,
              value: data,
            }));

          if (zipOptions) {
            // Extract all unique zip codes from data1
            const existingZipCodes = data1.reduce((acc, item) => {
              if (item.zipcodes) {
                acc.push(...item.zipcodes);
              }
              if (item.featured && item.featured.zipcodes) {
                acc.push(...item.featured.zipcodes);
              }
              if (item.normal) {
                item.normal.forEach((normalItem) => {
                  if (normalItem.zipcode) {
                    acc.push(normalItem.zipcode);
                  }
                });
              }
              return acc;
            }, []);

            const uniqueExistingZipCodes = [...new Set(existingZipCodes)];

            // Filter out zip codes that are already in data1
            const filtered = zipOptions.filter(
              (zip) => !uniqueExistingZipCodes.includes(zip.value)
            );

            setOptions(filtered);
            setSelectedZipCodes(filtered);
          }
        }
      } catch (error) {
        toast.error(error.message);
      }
    };

    const getManageAds = async () => {
      try {
        console.log("called");
        const response = await fetch(
          `${API}/advertiser/get-advertiser-ads/${advId}`
        );
        const json = await response.json();

        if (response.ok) {
          setData(json || []);
          getOptions(json);
        }
      } catch (error) {
        toast.error(error.message);
      } finally {
        // Any cleanup or final actions can be done here
      }
    };

    getManageAds();
  }, []);
  // useEffect(() => {

  //   const getOptions = async (data1) => {
  //     try {
  //       const response = await fetch(`${API}/auth/role-check/get-allZipCodes`);
  //       const json = await response.json();

  //       if (response.ok) {
  //         const zipOptions = json.map((data) => ({
  //           label: data.zipCode,
  //           value: data.zipCode,
  //         }));

  //         if (zipOptions) {
  //         // Filter out zip codes that are already in data1.zipcodes
  //           if(data1.length> 0){
  //             const filtered = zipOptions.filter(
  //               (zip) => !data1.zipcodes.includes(zip.value)
  //             );
  //             setOptions(filtered);
  //           }

  //         }
  //       }
  //     } catch (error) {
  //       toast.error(error.message);
  //     }
  //   };
  //   const getManageAds = async () => {
  //     try {
  //       console.log("called");
  //       const response = await fetch(
  //         `${API}/advertiser/get-advertiser-ads/${advId}`
  //       );
  //       const json = await response.json();

  //       if (response.ok) {
  //         setData(json || []);
  //         getOptions(json);
  //       }
  //     } catch (error) {
  //       toast.error(error.message);
  //     } finally {

  //     }
  //   };

  //   getManageAds();
  // }, []);

  const handleCheckClick = (zip) => {
    setSelected([...selected, zip]);
  };

  const handleRemoveItem = (zip) => {
    setSelected(selected.filter((item) => item !== zip));
    // Also remove from featured if it's there
    setFeatured(featured.filter((item) => item !== zip));
  };

  const handleExpand = (featuredZipCodes, normalZipCodes) => {
    // setNoraml(n || []);
    // setFeatured2(f || []);
    const result = normalZipCodes.map((normal, index) => ({
      featuredzipcode: featuredZipCodes[index] || "",
      normalzipcode: normal.zipcode,
    }));

    if (result) {
      setFeatured2(result);
    }
    openModal("expand");
  };
  const columns = [
    {
      name: "Ad Name",
      selector: (row, index) => (
        <div className="table-layout-content-header-box">
          <div className="table-layout-content-header-image">
            {row.image ? (
              <img
                src={row.image}
                className="table-layout-content-header-image-media img-fluid"
                alt=""
              />
            ) : (
              <img
                src="/img/user.png"
                className="table-layout-content-header-image-media img-fluid"
                alt=""
              />
            )}
          </div>
          <div className="table-layout-content-header-details">
            <h3 className="table-layout-content-header-details-name my-0">
              Ad {index + 1}
            </h3>
          </div>
        </div>
      ),
      sortable: false,
      minWidth: "400px",
    },
    {
      name: "Date Creation",
      selector: (row) => format(new Date(row.createdAt), "dd MMM, yyyy"),
      sortable: true,
    },
    {
      name: "Date Expiry",
      selector: (row) =>
        format(addDays(new Date(row.createdAt), 30), "dd MMM, yyyy"),
      sortable: true,
    },

    {
      name: "Action",
      selector: (row) => (
        <button
          className="tour-cta-1"
          onClick={() => handleExpand(row.featured.zipcodes, row.normal)}
        >
          Expand
        </button>
      ),
      sortable: false,
      minWidth: "200px",
    },
  ];

  const customStyles = {
    table: {
      style: {
        backgroundColor: "#252525!important",
      },
    },
    headCells: {
      style: {
        backgroundColor: "#1e1e1e",
        color: "#ffffff",
        fontSize: "16px",
        fontFamily: "Degular-Light",
      },
    },
    cells: {
      style: {
        fontSize: "14px",
        color: "#ffffff",
      },
    },
    rows: {
      style: {
        backgroundColor: "#252525",
        fontFamily: "Degular-Light",
      },
      highlightOnHoverStyle: {
        backgroundColor: "#e3f2fd",
        transition: "0.2s ease-in-out",
      },
    },
    pagination: {
      style: {
        backgroundColor: "#1e1e1e",
        fontSize: "14px",
        borderTop: "1px solid #ddd",
        color: "#ffffff",
      },
      pageButtonsStyle: {
        color: "#ffffff",
        fill: "#ffffff",
        "&:hover": {
          backgroundColor: "#252525",
          color: "#ffffff",
          fill: "#ffffff",
        },
        "&:disabled": {
          color: "#bdbdbd",
          fill: "#bdbdbd",
        },
      },
    },
  };

  const handleBuy = () => {
    if (featured.length < 1 && selected.length < 1) {
      toast.error("Please Select Featured or listing zip codes");
    } else {
      // Remove duplicates from featured and selected arrays
      const uniqueFeatured = [...new Set(featured)];
      const uniqueSelected = [...new Set(selected)];
      
      // Filter selectedZipCodes to only include zips that are in featured or selected
      const myzip = selectedZipCodes
        .map((zip) => zip.value)
        .filter(zip => uniqueFeatured.includes(zip) || uniqueSelected.includes(zip));
      
      // Store data in localStorage
      localStorage.setItem('advertiserCheckoutData', JSON.stringify({
        selectedZipCodes: myzip,
        featured: uniqueFeatured,
        selected: uniqueSelected
      }));
      
      navigate("/advertiser-checkout");
    }
  };
  const colorStyles = {
    control: (base, state) => ({
      ...base,
      backgroundColor: "#252525",
      borderColor: state.isFocused ? "#252525" : "#252525",
      boxShadow: state.isFocused ? "none" : "none",
      borderRadius: "20px", // Adjust the border-radius as needed
      minHeight: "66px", // Increase the height
      padding: "10px",
      "&:hover": {
        borderColor: "#252525",
      },
      "&:focus": {
        borderColor: "#252525",
      },
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected
        ? "#24A97B"
        : state.isFocused
          ? "#252525"
          : "#252525",
      borderRadius: "20px",

      color: state.isSelected ? "black" : "white",
      "&:hover": {
        backgroundColor: "#000000",
      },
    }),
    menu: (base) => ({
      ...base,
      backgroundColor: "#252525",
      border: "1px solid #252525",
      borderRadius: "20px", // Add border-radius to the dropdown menu
      fontFamily: "Degular-Light",
      fontSize: "14px",
      padding: "10px",
    }),
    placeholder: (base) => ({
      ...base,
      color: "#ffffff",
      fontFamily: "Degular-Light",
      fontSize: "14px",
      opacity: "0.7",
    }),
    singleValue: (base) => ({
      ...base,
      color: "#ffffff",
      fontFamily: "Degular-Light",
      fontSize: "14px",
    }),
    input: (base) => ({
      ...base,
      color: "#ffffff",
    }),
    multiValue: (base) => ({
      ...base,
      backgroundColor: "#000000",
      fontFamily: "Degular-Light",
      fontSize: "14px",
    }),
    multiValueLabel: (base) => ({
      ...base,
      color: "#ffffff",
      fontFamily: "Degular-Light",
      fontSize: "14px",
    }),
    multiValueRemove: (base) => ({
      ...base,
      color: "#ffffff",
      "&:hover": {
        backgroundColor: "red",
        color: "white",
      },
    }),
  };

  return (
    <div className="agent-lead">
      <h2 className="user-layout-page-heading">Manage Ads</h2>

      <div className="container-fluid agent-buy-leads-container">
      

        {/* Select Zip Code Modal */}
        <Modal
          width={{
            xs: "100%",
            sm: "100%",
            md: "70%",
            lg: "70%",
            xl: "65%",
            xxl: "65%",
          }}
          centered
          open={modalType === "terms"}
          footer={null}
          closable={false}
        >
          <div
            className={`container-fluid pop-up-leads ${isMobile ? "px-0" : ""}`}
          >
            <h2 className="lead-pop-heading">
              Select Zip Code to Advertise To
            </h2>
            <div className="col-12" style={{ marginBottom: "20px" }}>
              <Select
                isMulti
                styles={colorStyles}
                options={options}
                classNamePrefix="select"
                placeholder="Choose Zip Codes..."
                onChange={handleZipChange}
                value={selectedZipCodes}
              />
            </div>
            <div className="row">
              <div className="col-md-6">
                <button
                  className="btn user-register-button"
                  onClick={() => openModal("preference")}
                >
                  Next
                </button>
              </div>
              <div className="col-md-6">
                <button
                  onClick={closeModal}
                  className="btn schedule-tour-skip-button"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </Modal>

        {/* Preferences Modal */}
        <Modal
          centered
          open={modalType === "preference"}
          footer={null}
          closable={false}
          width={{
            xs: "100%",
            sm: "100%",
            md: "70%",
            lg: "70%",
            xl: "65%",
            xxl: "65%",
          }}
        >
          <div
            className={`container-fluid pop-up-leads ${isMobile ? "px-0 " : ""}`}
          >
            <h2 className="lead-pop-heading">Preferences</h2>
            <table className="table ads-table">
              <thead className="ads-table-head">
                <tr className="ads-table-row-head">
                  <th className="ads-table-data-head-1">Zip Codes</th>
                  <th className="ads-table-data-head">Featured</th>
                  <th className="ads-table-data-head-last">Listing</th>
                </tr>
              </thead>
              <tbody className="ads-table-body">
                {selectedZipCodes.map((zip) => (
                  <tr key={zip} className="ads-table-body-row">
                    <td className="ads-table-data">
                      <div className="tour-date w-100 ps-3 text-start">
                        {zip.value}
                      </div>
                    </td>
                    <td className="ads-table-data-1">
                      <div className="table-layout-content-header-box d-flex justify-content-center">
                        
                        {featured.includes(zip.value) ? (
                          <img
                            role="button"
                            src="/img/checked.svg"
                            className="img-fluid me-3"
                            alt=""
                            onClick={() => {
                              setFeatured(
                                featured.filter((item) => item !== zip.value)
                              );
                              // Also remove from selected if it's there
                              setSelected(
                                selected.filter((item) => item !== zip.value)
                              );
                            }}
                          />
                        ) : (
                          <img
                            role="button"
                            src="/img/uncheck.svg"
                            className="img-fluid opacity-50 me-3"
                            alt=""
                            onClick={() => {
                              setFeatured([...featured, zip.value]);
                              handleCheckClick(zip.value);
                            }}
                          />
                        )}
                      </div>
                    </td>
                    <td className="ads-table-data-last">
                      <div className="tour-date w-100 pe-3 text-end">
                        {" "}
                        {selected.includes(zip.value) ? (
                          <img
                            role="button"
                            src="/img/checked.svg"
                            className="img-fluid me-3"
                            alt=""
                            onClick={() => handleRemoveItem(zip.value)}
                          />
                        ) : (
                          <img
                            role="button"
                            src="/img/uncheck.svg"
                            className="img-fluid opacity-50 me-3"
                            alt=""
                            onClick={() => handleCheckClick(zip.value)}
                          />
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="row">
              <div className="col-md-6">
                <button
                  className="btn user-register-button"
                  onClick={handleBuy}
                >
                  Buy Now
                </button>
              </div>
              <div className="col-md-6">
                <button
                  onClick={closeModal}
                  className="btn schedule-tour-skip-button"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </Modal>
        {/*Expand Modal */}
        <Modal
          centered
          open={modalType === "expand"}
          footer={null}
          closable={false}
          width={{
            xs: "100%",
            sm: "100%",
            md: "70%",
            lg: "70%",
            xl: "65%",
            xxl: "65%",
          }}
        >
          <div
            className={`container-fluid pop-up-leads ${isMobile ? "px-0 " : ""}`}
          >
            <h2 className="lead-pop-heading">Zipcodes</h2>
            <table className="table ads-table">
              <thead className="ads-table-head">
                <tr className="ads-table-row-head">
                  <th className="ads-table-data-head-1" style={{backgroundColor: "red!important"}}>Featured</th>
                  <th className="ads-table-data-head">
                    {" "}
                    <span style={{ opacity: "0" }}>Featured</span>
                  </th>
                  <th className="ads-table-data-head-last">Normal</th>
                </tr>
              </thead>
              <tbody className="ads-table-body">
                {featured2 &&
                  featured2.map((zip) => (
                    <tr className="ads-table-body-row">
                      <td className="ads-table-data">
                        <div className="tour-date w-100 ps-3 text-start">
                        {zip.featuredzipcode}
                        </div>
                      </td>
                      <td className="ads-table-data-1">
                        <div
                          className="table-layout-content-header-box d-flex justify-content-center"
                          style={{ opacity: "0" }}
                        >
                          <img
                            role="button"
                            src="/img/checked.svg"
                            className="img-fluid me-3"
                            alt=""
                          />
                        </div>
                      </td>
                      <td className="ads-table-data-last">
                        <div className="tour-date w-100 pe-3 text-end">
                       
                          {zip.normalzipcode}
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
            <div className="row">
              <div className="col-md-12">
                <button
                  onClick={closeModal}
                  className="btn schedule-tour-skip-button"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </Modal>

        {/* Empty State */}
        <div className="row">
          {data.length > 0 ? (
            <div className="col-12 px-0 pt-4">
              <DataTable
                columns={columns}
                data={data}
                pagination
                paginationPerPage={15}
                paginationRowsPerPageOptions={[10, 15, 20, 50]}
                customStyles={customStyles}
                progressPending={loading}
                progressComponent={
                  <div className="text-center my-2 bg-white">
                    <div
                      className="spinner-border text-secondary"
                      role="status"
                    >
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                }
                className="table table-striped table-hover"
              />
            </div>
          ) : (
            <div className="col-12 px-0 d-flex justify-content-center align-items-center flex-column">
              <img
                src="/img/leadership-empty.svg"
                className="img-fluid pirate-image"
                alt=""
              />
              <h2 className="leadership-empty-heading">You have no ads!</h2>
              <p className="leadership-empty-para mt-2" style={{fontSize: "22px"}}>
                <b>Let’s create some.</b>
              </p>
            </div>
          )}
        </div>
        <div className="row">
          <div className="col-12 px-0 pt-4 d-flex justify-content-center">
          <button
          className="btn buy-lead-button"
          onClick={() => openModal("terms")}
        >
          Request advertisement
        </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ManageAds;
